import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StatusPage from '../StatusPage';

class BasicErrorBoundary extends Component {
    static propTypes = {
        children: PropTypes.any
    };

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error) {
        console.error(error);
        if (error.message === 'Catastrophe') {
            this.setState({ hasError: true });
            console.error(error);
        }
    }

    render() {
        if (this.state.hasError) {
            return <StatusPage />;
        }
        return this.props.children;
    }
}

export default BasicErrorBoundary;
